/*eslint-disable no-unused-vars*/
import React from 'react';
/*eslint-disable no-unused-vars*/
import TopOfGoalPost from './TopOfGoalPost';
// import TopOfGoalPost from './TopOfGoalPostCache'; // Book Cache Testing Changed
import assembleFork from '../Fork/';
// import assembleFork from '../Fork/indexCache'; // Book Cache Testing Changed
import { handleHeight, goalPostHeight } from '../../library/constants';

const assembleGoalPost = ({ union, nodeObjs, unionIsRelated, centerXFromChildren, minimap, stageBackgroundCustomColor }) => {

  const nodeObj_1 = nodeObjs[union['p'][0]];
  const nodeObj_2 = nodeObjs[union['p'][1]];
  const goalPostWidth = Math.abs(nodeObj_2['xCenter'] - nodeObj_1['xCenter']);
  let leftPartnerNode = ( nodeObj_1.g ==='m' ? nodeObj_1 : nodeObj_2);

  if( (nodeObj_1.g === 'f' && nodeObj_2.g === 'f') ||  // lesbians
      (nodeObj_1.g === 'u' && nodeObj_2.g === 'f') ||  // first partner transgender
      (nodeObj_1.g === 'f' && nodeObj_2.g === 'u') ||  // second partner transgender
      (nodeObj_1.g === 'u' && nodeObj_2.g === 'u')     // both transgender
  ){
    leftPartnerNode = ( nodeObj_1.xCenter < nodeObj_2.xCenter ? nodeObj_1: nodeObj_2);
  }

  // let xHandlePos = leftPartnerNode['xCenter'] + ( goalPostWidth / 2 );
  let xHandlePos = union.xHandlePos;

  let startYOfHandle = nodeObj_1['bottom'] + goalPostHeight;
  // const endYOfHandle = union.forkBaseYPos + union.heightBetweenSegments;
  // const endYOfHandle = union.forkBaseYPos + 1.5;
  const endYOfHandle = ((handleHeight * 2) + nodeObj_1['bottom']) - 1;

  const ForkComponentsAssembledArrayOfOne = assembleFork({ union, nodeObjs, xHandlePos, startYOfHandle, endYOfHandle, unionIsRelated, stageBackgroundCustomColor });
  let combinedComponentsArray = [
    <TopOfGoalPost  key={Math.random()} {...{ union, nodeObjs, startYOfHandle, unionIsRelated, minimap, stageBackgroundCustomColor }}/>,
    ...ForkComponentsAssembledArrayOfOne
  ];
  return combinedComponentsArray;
};

export default assembleGoalPost;
